/**
 * @author Ryan Gladstone, Umer Hassan
 * Webpack migration by Umer Hassan
 */

function vizMedianDeadlineMissController($scope, $translate, statsService, $log) {
  const endTime = Math.floor(Date.now() / 1000);
  const startTime = endTime - (3600 * 24);

  statsService.getMedianDeadlineMiss(
    startTime,
    endTime,
    $scope.filterSet.getFilterValue('sections'),
    $scope.filterSet.getFilterValue('platforms')
  )
    .then((data) => {
      if (Number.isNaN(Number(data))) {
        $scope.deadlineMiss = $translate.instant('NO_DATA');
      } else {
        $scope.deadlineMiss = `${data} ${$translate.instant('MINUTES')}`;
      }
    }, (response) => {
      $log.error('vizMedianDeadlineMissCtrl() error: ', response);
      $scope.deadlineMiss = $translate.instant('ERROR');
    });

  $scope.deadlineMiss = '';
}


function directive() {
  return {
    restrict: 'E',
    scope: {
      filterSet: '='
    },
    template: '<h4>{{ deadlineMiss }}</h4><twp-translate>MEDIAN_DEADLINE_MISS</twp-translate>',
    controller: ['$scope',
      '$translate',
      'statsService',
      '$log',
      vizMedianDeadlineMissController]
  };
}

export default function (ngModule) {
  ngModule.directive('vizMedianDeadlineMiss', directive);
}
